var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1655,
    zoomAndPan: "magnify",
    viewBox: "0 0 1241.25 809.999971",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0377f89bee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.246094 L 1240.5 0.246094 L 1240.5 809.753906 L 0 809.753906 Z M 0 0.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "088e4ff75f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 453.433594 205.972656 L 1001.992188 205.972656 L 1001.992188 543.820312 L 453.433594 543.820312 Z M 453.433594 205.972656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b0b0811842"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 61.082031 63.058594 L 537.792969 63.058594 L 537.792969 542 L 61.082031 542 Z M 61.082031 63.058594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf134b481e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 696.679688 63.007812 L 1173 63.007812 L 1173 538.222656 L 696.679688 538.222656 Z M 696.679688 63.007812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "862c42f5e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 696.5 254 L 1167.214844 254 L 1167.214844 725.855469 L 696.5 725.855469 Z M 696.5 254 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be96e19292"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 61.085938 253.636719 L 537.796875 253.636719 L 537.796875 728.800781 L 61.085938 728.800781 Z M 61.085938 253.636719 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0377f89bee)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.246094 L 1240.5 0.246094 L 1240.5 809.753906 L 0 809.753906 Z M 0 0.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.246094 L 1240.5 0.246094 L 1240.5 809.753906 L 0 809.753906 Z M 0 0.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#088e4ff75f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 453.433594 205.972656 L 1002.433594 205.972656 L 1002.433594 543.820312 L 453.433594 543.820312 Z M 453.433594 205.972656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b0b0811842)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e23419",
    d: "M 60.894531 541.207031 L 60.894531 63.542969 L 537.792969 63.542969 Z M 60.894531 541.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf134b481e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7e937",
    d: "M 696.976562 63.054688 L 1172.90625 63.054688 L 1172.90625 538.222656 Z M 696.976562 63.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#862c42f5e6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#15bc6b",
    d: "M 696.488281 254.117188 L 696.488281 725.601562 L 1167.214844 725.601562 Z M 696.488281 254.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be96e19292)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b067a",
    d: "M 61.382812 728.800781 L 537.3125 728.800781 L 537.3125 253.636719 Z M 61.382812 728.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1964940d1ed027852540bfbaa57cef03.svg";
export { ForwardRef as ReactComponent };